import SITE_ENVIRONMENTS from 'constants/websites'
import { BillsPage, FdrPage, FfnPage, WfsPage } from 'utils/environmentConfig/constants'

/**
 * Single source for header/footer Layout `siteEnv` when build-time public env
 * does not match the brand returned from Contentful (e.g. Achieve .env with FDR page data).
 */
export function resolveLayoutSiteEnv({ header, siteInfo, publicProcessDotEnv } = {}) {
  const fromHeader = header?.siteEnv
  if (typeof fromHeader === 'string' && fromHeader.length > 0) {
    return fromHeader
  }

  const url = [siteInfo?.publicUrl, siteInfo?.url].find(
    (u) => typeof u === 'string' && u.length > 0
  )
  if (typeof url === 'string') {
    const u = url.toLowerCase()
    if (u.includes('freedomdebtrelief.com')) return FdrPage
    if (u.includes('weeklyfinancialsolutions.com')) return WfsPage
    if (u.includes('freedomfinancialnetwork.com')) return FfnPage
    if (u.includes('bills.com')) return BillsPage
    if (u.includes('achieve.com')) return SITE_ENVIRONMENTS.ACHIEVE
  }

  const fromPublic =
    process.env.NEXT_PUBLIC_SITE_ENVIRONMENT || publicProcessDotEnv?.NEXT_PUBLIC_SITE_ENVIRONMENT
  if (typeof fromPublic === 'string' && fromPublic.length > 0) {
    return fromPublic
  }

  return SITE_ENVIRONMENTS.DEFAULT
}
